
export class EnrollQuota {
  quotaid: number;
  file: any = {fileId: null};
}



// WEBPACK FOOTER //
// ./src/app/modules/enroll/components/model/enroll-quota.ts